module.exports = __webpack_public_path__ + "media/packs/site/assets/images/brand_site-cbe2af258513b13efc972d89e8be9c2c.png";